import { useWorkspaceSelection } from "../workspaceSelection/WorkspaceSelectionContext";
import { useSessionSipActivity } from "./SessionSipActivityContext";
import "./SessionActivityControls.css";

export default function SessionActivityControls({ onlyChanged, onOnlyChangedChange, className = "" }) {
  const { items, selectionItems, clearActivity } = useSessionSipActivity();
  const { addItems } = useWorkspaceSelection();

  return (
    <div className={`session-activity-toolbar${className ? ` ${className}` : ""}`}>
      <div className="session-activity-toolbar__summary">
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <path d="M3 12a9 9 0 1 0 3-6.7" />
          <path d="M3 4v6h6M12 7v5l3 2" />
        </svg>
        <span>Изменено в сессии</span>
        <span className="session-activity-toolbar__count" aria-label={`${items.length} изменённых документов`}>{items.length}</span>
      </div>

      <div className="session-activity-toolbar__actions">
        <button
          type="button"
          className={`session-activity-toolbar__button session-activity-toolbar__toggle${onlyChanged ? " session-activity-toolbar__toggle--active" : ""}`}
          aria-pressed={onlyChanged}
          title="Показывать только изменённые в текущей сессии документы"
          onClick={() => onOnlyChangedChange(!onlyChanged)}
        >
          <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 6h16l-6 7v5l-4 2v-7Z" /></svg>
          Только изменённые
        </button>
        <button type="button" className="session-activity-toolbar__button" disabled={!items.length} onClick={() => addItems(selectionItems)}>
          В подборку
        </button>
        <button type="button" className="session-activity-toolbar__button" disabled={!items.length} onClick={() => { clearActivity(); onOnlyChangedChange(false); }}>
          Очистить
        </button>
      </div>
    </div>
  );
}
